<template>
  <section id="pricing-plan">
    <!-- title text and switch button 
    <div class="text-center">
      <h1 class="mt-5">Tipi di licenza</h1>
      <p class="mb-2 pb-75">Scegli il tipo di licenza più adatto alle tue esigenze.</p>
    </div>
    <!--/ title text and switch button -->

    <!--
    <b-row>
      <b-col md="6" offset-md="3" lg="4" offet-lg="4">
        <b-card align="center">
          <form ref="formPricing">
            <h2 class="mt-5">Contattaci per ricevere informazioni sui prezzi</h2>
            <b-form-group label="Nome">
              <b-form-input :value="fullName" disabled></b-form-input>
            </b-form-group>
            <b-form-group label="Quanti crediti vuoi acquistare?">
              <b-form-textarea></b-form-textarea>
            </b-form-group>
            <div class="text-right">
              <b-button variant="primary" @click="sendPricingRequest">Invia</b-button>
            </div>
            <b-alert class="mt-3" dismissible variant="success" :show="showSuccess">Abbiamo ricevuto il tuo messaggio<br>Un nostro commerciale ti contatterà al più presto.</b-alert>
            <b-alert class="mt-3" dismissible variant="danger" :show="showDanger">Si è verificato un problema nell'invio del messaggio.<br>Ti pregrhiamo di riprovare.</b-alert>
          </form>
        </b-card>
      </b-col>
    </b-row>
    -->
    <!-- OLD: pricing plan cards -->
    <!--
    <b-row class="pricing-card" v-if="pricing">
      <b-col offset-sm-2 sm="10" md="12" offset-lg="2" lg="10" class="mx-auto">
        <b-row class="justify-content-center align-items-stretch">
          
          <b-col md="4" class="d-flex flex-column justify-content-stretch">
            <b-card align="center">
              <h3>A Consumo</h3>
              
              <div class="d-flex flex-column">
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <div v-if="discount(pricing[3])" class="pricing-basic-value text-strikethrough text-primary">€ {{ priceFormatter.format(price(pricing[3])) }}</div>
                    <div v-else class="pricing-basic-value text-primary">&nbsp;</div>
                    <sup class="font-medium-1 font-weight-bold text-primary">€</sup>
                    <span class="pricing-basic-value font-weight-bolder text-primary">{{ priceFormatter.format(finalPrice(pricing[3])) }}</span>
                    <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/progetto</sub>
                  </div>
                </div>
                <ul class="text-left mb-3 flex-grow-1">
                  <li>Paghi per ogni progetto realizzato</li>
                </ul>
                <b-button @click="$router.push('/cart?type=4')" variant="primary">Seleziona</b-button>
              </div>
            </b-card>
          </b-col>

          <b-col md="4" class="d-flex flex-column justify-content-stretch">
            <b-card align="center">
              <h3>Mensile</h3>
              <div class="d-flex flex-column">
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <div v-if="discount(pricing[1])" class="pricing-basic-value text-strikethrough text-primary">€ {{ priceFormatter.format(price(pricing[1])) }}</div>
                    <div v-else class="pricing-basic-value text-primary">&nbsp;</div>
                    <sup class="font-medium-1 font-weight-bold text-primary">€</sup>
                    <span class="pricing-basic-value font-weight-bolder text-primary">{{ priceFormatter.format(finalPrice(pricing[1])) }}</span>
                    <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/mese</sub>
                    <div class="mt-2"><small>{{ priceFormatter.format(finalPrice(pricing[1]) * 12)}}/anno</small></div>

                  </div>
                </div>
                <ul class="text-left mb-3 flex-grow-1">
                  <li>Progetti Nuovi Impianti: {{ newProjectCredit(pricing[1]) > 200 ? 'Illimitati' : newProjectCredit(pricing[1])}}</li>
                  <li>Progetti Manutenzione Impianti: {{ newProjectCredit(pricing[1]) > 200 ? 'Illimitati' : newProjectCredit(pricing[1])}}</li>
                  <li>Durata abbonameno: 1 Mese</li>
                </ul>
                <b-button @click="$router.push('/cart?type=2')" variant="primary">Seleziona</b-button>
              </div>


            </b-card>
          </b-col>

          <b-col md="4" class="d-flex flex-column justify-content-stretch">
            <b-card align="center">
              <h3>Annuale</h3>
              <div class="d-flex flex-column">
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <div v-if="discount(pricing[2])" class="pricing-basic-value text-strikethrough text-primary">€ {{ priceFormatter.format(price(pricing[2])) }}</div>
                    <div v-else class="pricing-basic-value text-primary">&nbsp;</div>
                    <sup class="font-medium-1 font-weight-bold text-primary">€</sup>
                    <span class="pricing-basic-value font-weight-bolder text-primary">{{ priceFormatter.format(finalPrice(pricing[2]) / 12) }}</span>
                    <sub class="pricing-duration text-body font-medium-1 font-weight-bold mb-2">/mese</sub>
                    <div class="mt-2"><small>{{ priceFormatter.format(finalPrice(pricing[2]))}}/anno</small></div>
                  </div>
                </div>
                <ul class="text-left mb-3">
                  <li>Progetti Nuovi Impianti: {{ newProjectCredit(pricing[2]) > 200 ? 'Illimitati' : newProjectCredit(pricing[2])}}</li>
                  <li>Progetti Manutenzione Impianti: {{ newProjectCredit(pricing[2]) > 200 ? 'Illimitati' : newProjectCredit(pricing[2])}}</li>
                  <li>Durata abbonameno: 12 Mesi</li>
                </ul>
                <b-button @click="$router.push('/cart?type=3')" variant="primary">Seleziona</b-button>
              </div>

            </b-card>
          </b-col>
  
        </b-row>
      </b-col>
    </b-row>
    -->
    <!--/ pricing plan cards -->

    <b-row>
      <b-col sm="12" md="6" lg="4" xl="3" class="d-flex flex-column justify-content-stretch" v-for="price in pricing" :key="price.id_package">
        <b-card align="center">
          <h3>{{ price.package_code }}</h3>
          <p class="mx-2">{{ price.package_description }}</p>
          <div class="d-flex flex-column">
            <div class="">
              <div class="plan-price mt-2">
                <h3 v-if="price.price" class="pricing-basic-value font-weight-bolder text-primary">€ {{ priceFormatter.format(Number(price.price)) }}</h3>
              </div>
            </div>
            <ul class="text-left mb-3 flex-grow-1">
              <li>Progetti Nuovi Impianti: {{ price.credit_installer }}</li>
              <li>Progetti Manutenzione Impianti: {{ price.credit_mantainer }}</li>
              
            </ul>
            <b-button @click="$router.push(`/cart?id_package=${price.id_package}`)" variant="primary">Seleziona</b-button>
          </div>

        </b-card>
      </b-col>

    </b-row>




  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge, BFormInput, BFormTextarea, BFormGroup, BAlert
} from 'bootstrap-vue'

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
import { Requests } from '@/api/requests'
import { ValidationObserver, ValidationProvider, localize } from 'vee-validate';
/* eslint-disable global-require */
export default {
  components: {
    BAlert,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
    BFormInput,
    BFormTextarea
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      pricing: null,
      priceFormatter: new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
      showSuccess: false,
      showDanger: false,
      pageLength: 10,
      columns: [
        {
          label: "ID",
          field: "id_package",
          type: 'number'
        },
        {
          label: "Crediti Installatore",
          field: "credit_installer",
          type: 'number'
        },
        {
          label: "Crediti Manutentore",
          field: "credit_mantainer",
          type: 'number'
        },
        {
          label: "Descrizione",
          field: "package_description",
        },
        {
          label: "Codice",
          field: "package_code",
        },
        {
          label: "Prezzo",
          field: "price",
        },
        {
          label: "Azioni",
          field: "action",
        },
      ],
      tableItems: [],
      searchTerm: "",
    }
  },

  computed: {
    userData: function () {
      return JSON.parse(localStorage.getItem("user"));
    },
    fullName: function () {
      return this.userData.user_name + ' ' + this.userData.user_surname;
    }
  },

  created() {
    this.getPricing();

  },

  methods: {
    price: function (plan) {
      return Number(plan["price_type_" + this.userData.account_type_code]);
    },
    discount: function (plan) {
      return Number(plan["discount_type_" + this.userData.account_type_code]);
    },
    finalPrice: function (plan) {
      return this.price(plan) * (100 - this.discount(plan)) / 100;
    },
    newProjectCredit: function (plan) {
      return plan["project_limit_type_newimplant_" + this.userData.account_type_code];
    },
    maintenanceProjectCredits: function (plan) {
      return plan["project_limit_type_mantenance_" + this.userData.account_type_code];
    },
    async getPricing() {
      const response = await Requests.getPricing();
      this.pricing = response.data;
      console.log(this.pricing);
    },
    sendPricingRequest: async function () {
      this.showDanger = false;
      this.showSuccess = false;
      const response = await Requests.sendPricingRequest({ text: this.$refs.formPricing.querySelector('textarea').value });

      if ('alert-success' in response.data) {
        this.showSuccess = true;
      } else {
        this.showDanger = true;
      }
    }
  },

}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";

.card {
  flex: 1;
}

.text-strikethrough {
  font-size: 20px !important;
  text-decoration: line-through;
}

.card-body {
  display: flex;
  flex-direction: column;
}

.card-body div.d-flex {
  flex: 1;
}
</style>
